import React from 'react';
import { PhotoIcon } from '@heroicons/react/24/outline';

interface PlaceholderImageProps {
  className?: string;
  text?: string;
}

const PlaceholderImage: React.FC<PlaceholderImageProps> = ({
  className = "w-full h-full",
  text = "Фото недоступно"
}) => {
  return (
    <div className={`${className} bg-gray-100 flex flex-col items-center justify-center text-gray-400`}>
      <PhotoIcon className="h-12 w-12 mb-2" />
      <span className="text-sm text-center px-2">{text}</span>
    </div>
  );
};

export default PlaceholderImage;